module.exports = { "default": require("core-js/library/fn/reflect/construct"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/core-js/reflect/construct.js
// module id = 359
// module chunks = 0